import accountLogo from "./img/default_account_logo.png"
import complianceSetLogo from "./img/default_compliance_set_logo.png"
import defaultLogo from "./img/default_logo.png"
import projectLogo from "./img/default_project_logo.png"
import qidCompanyLogo from "./img/default_qid_company_logo.png"
import qidProductLogo from "./img/default_qid_product_logo.png"
import silDeviceLogo from "./img/default_sil_device_logo.png"

import noAvatar from "./img/no_avatar.png"
import noImage from "./img/no_image.png"

import downwardArrow from "./img/downward_arrow.png"

const Images = {
    accountLogo,
    complianceSetLogo,
    defaultLogo,
    projectLogo,
    qidCompanyLogo,
    qidProductLogo,
    silDeviceLogo,
    noAvatar,
    noImage,
    downwardArrow,
}
export default Images
